module.exports = __webpack_public_path__ + "static/media/box.20be8595.svg";